import React, { useEffect, useRef, useState } from 'react';
import servicesApi from '../../seller-apis/servicesApi';
import api from '../../seller-apis/api';
import './branddropdown.css';
import { useAlert } from 'react-alert';

function BrandDropDown(props) {
    const alert = useAlert();

    const [dropdown, setDropdown] = useState(false);
    const {
        search,
        setSearch,
        label,
        list,
        setState,
        newBrand,
        setNewBrand,
        newBrandLabel,
        newBrandFlag,
        setNewBrandFlag,
        setError,
        handleDropDownClick,
        error,
        isEditable
    } = props;

    const dropdownRef = useRef(null);

    const showDropdown = () => {
        setDropdown(true);
    }

    const hideDropdown = (name, index) => {
        try {
            api.TradeMark.checkBrand({ "name": name }).then((res) => {
                if (!res?.data?.isBrandRequested) {
                    handleDropDownClick(res.data.data)
                    setError(false)
                    setSearch(name)
                    setNewBrand(name)
                    setState(index)
                    setDropdown(false);
                } else {
                    alert.info(res?.data?.message)
                }
            }
            )
        } catch (error) {
            console.log("Error")
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdown(false);
            }
        };

        if (dropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdown]);
    return (
        <div className='select-container' ref={dropdownRef}>
            <label>Brand Name *</label>
            <br />
            <input
                type="text"
                placeholder={label}
                onChange={(e) => {
                    if(isEditable){
                        setSearch(e.target.value);
                        setNewBrand(e.target.value)
                        setError(false)
                    }
                    else{
                        alert.info("Not allowed!")
                    }
                }}
                value={newBrand}
                onFocus={
                    isEditable?
                        showDropdown:<></>
                }
            />
            {
                dropdown ?
                    <div className='dropdown-list'>
                        <ul className='ul-custom'>
                            {
                                list.map(
                                    (item, index) =>
                                        !search.length || new RegExp(search, 'i').test(item.name) ?
                                            <li value={index} key={item._id} onClick={() => hideDropdown(item.name, index)}>
                                                {item.name}
                                            </li>
                                            : null)
                            }
                        </ul>
                        {/* <div className='add-new-brand-container' onClick={addNewBrand}>
                            <img src="/brand/add-circle.png" alt='cross' height={18} className='my-auto' />
                            <div className="heading my-auto">
                                Add New Brand
                            </div>
                        </div> */}
                    </div>
                    : null
            }
            {/* {
                newBrandFlag ?
                    <div className='row mx-0 mt-4 align-items-center'>
                        <div className='col-11 px-0'>
                            <input
                                type="text"
                                placeholder={newBrandLabel}
                                onChange={(e) => { setNewBrand(e.target.value); setError(false) }}
                                value={newBrand}
                            />
                        </div>
                        <div className='col-1 text-end px-0'>
                            <img src="/brand/cross-circle.png" alt='cross' height={27} className='ms-auto me-2 cursor-pointer' onClick={removeNewBrand} />
                        </div>
                    </div>
                    : null
            } */}
            {
                error ?
                    <span className="text-danger" style={{ fontFamily: 'Inter', fontWeight: '500' }}>{error}</span>
                    : null
            }

        </div>
    )

}

export default BrandDropDown;